import { createReducer, on } from '@ngrx/store';
import { ICacheState } from './cache.interface';
import { CacheActions } from './cache.actions';

export const cacheFeatureKey = 'cache';

export type IState = ICacheState;

export const initialState: IState = {
	loading: false,
	clearing: false,
	refreshingContext: null,
	contexts: {},
	degradedContexts: [],
};

export const reducer = createReducer(
	initialState,

	// ── API ──

	on(
		CacheActions.loadStats,
		(state): IState => ({
			...state,
			loading: true,
			error: undefined,
			// NOT cleared here, unlike `error`. `contexts` is kept across a reload
			// too, so clearing this would render the previous partial context map
			// with the warning hidden — the exact silent-partial-data state this
			// banner exists to prevent. Both are replaced together on success.
		}),
	),
	on(
		CacheActions.loadStatsSuccess,
		(state, action): IState => ({
			...state,
			loading: false,
			error: undefined,
			contexts: action.contexts,
			degradedContexts: action.degradedContexts,
		}),
	),
	on(
		CacheActions.loadStatsError,
		(state, action): IState => ({
			...state,
			loading: false,
			error: action.error,
		}),
	),
	on(
		CacheActions.loadContextStats,
		(state, action): IState => ({
			...state,
			refreshingContext: action.context,
			error: undefined,
		}),
	),
	on(
		CacheActions.loadContextStatsSuccess,
		(state, action): IState => ({
			...state,
			refreshingContext: null,
			contexts: { ...state.contexts, [action.context]: action.stats },
		}),
	),
	on(
		CacheActions.loadContextStatsError,
		(state, action): IState => ({
			...state,
			refreshingContext: null,
			error: action.error,
		}),
	),
	on(
		CacheActions.clearCache,
		(state): IState => ({
			...state,
			clearing: true,
			error: undefined,
		}),
	),
	on(
		CacheActions.clearCacheSuccess,
		(state): IState => ({
			...state,
			clearing: false,
			error: undefined,
		}),
	),
	on(
		CacheActions.clearCacheError,
		(state, action): IState => ({
			...state,
			clearing: false,
			error: action.error,
		}),
	),

	// ── UI ──

	on(
		CacheActions.clearError,
		(state): IState => ({
			...state,
			error: undefined,
		}),
	),
);
